import { LINKTAGSARRAY } from '@qaroni-merchant-core/types/metadata/link-tags.array';

const linkTagsPromise = (): Promise<void> => {
  return new Promise(resolve => {
    LINKTAGSARRAY.forEach(tag => {
      const link = document.createElement('link');
      link.rel = tag.rel;
      link.href = tag.href;

      if (tag.type) {
        link.type = tag.type;
      }

      if (tag.sizes) {
        Object.defineProperty(link, 'sizes', {
          value: tag.sizes,
          writable: true,
        });
      }
      document.head.appendChild(link);
    });

    resolve();
  });
};

export function initializeLinkTags(): () => Promise<void> {
  return () => linkTagsPromise();
}
